import React, { useContext } from "react";

import { NavLink, useRouteMatch } from "react-router-dom";

import { DEFAULT_SECTION } from "@data-types/offer/event/EventViewStoreEnums";
import { EventOffer, LookupsStore } from "@gp/offer";
import { history } from "@state";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";
import { observer } from "mobx-react";

import { ToggleIsEventInOfferButton } from ".";

export const SubMenuList = observer(function SubMenuList(props: {
	culture: string;
	eventOfferList: EventOffer[];
	lookupsStore: LookupsStore;
}) {
	const liveEventMenuStore = useContext(LiveEventSideMenuContext);
	const liveMatch = useRouteMatch<{ period: string }>(
		"/:culture/live/:period"
	);
	const section = liveMatch?.params.period ?? DEFAULT_SECTION;
	return (
		<>
			{props.eventOfferList.map((event) => {
				const isEventActive =
					liveEventMenuStore.cleanedEventIds.includes(event.id);
				const t1 = props.lookupsStore.teams.get(event.teamOneId || "");
				const t2 = props.lookupsStore.teams.get(event.teamTwoId || "");

				return (
					<li
						key={event.id}
						className="nav--quaternary__item nav--multi__item"
					>
						<ToggleIsEventInOfferButton
							event={event}
							isEventActive={isEventActive}
						/>
						<NavLink
							className="nav--quaternary__link nav--multi__link"
							activeClassName="is-selected"
							isActive={() => isEventActive}
							to={{
								pathname: `/${props.culture}/live/${section}/${event.id}-myBets=false`,
								state: {
									prevUrl:
										history.location.pathname +
										history.location.search,
									eventIdsForEventSwitcher:
										liveEventMenuStore.orderEvents,
								},
							}}
						>
							<span className="nav--multi__label">
								{t1?.name} - {t2?.name}
							</span>
						</NavLink>
					</li>
				);
			})}
		</>
	);
});
